import React, {Suspense, useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {DialogEscapeKey} from '../_metronic/helpers/components/DialogEscapeKey'
import {AuthInit} from './modules/auth'
import ErrorBoundary from './ErrorBoundary'

const App = () => {
  setTimeout(() => {
    window.addEventListener('popstate', (e) => {
      window.history.pushState('', document.title, window.location.pathname)
    })
  }, 10)

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <LayoutProvider>
        <ErrorBoundary>
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
          <DialogEscapeKey />
        </ErrorBoundary>
      </LayoutProvider>
    </Suspense>
  )
}

export {App}
